import { type ComponentPropsWithoutRef } from 'react';

import { cn } from '../../lib/utils';

const DOT_INDICES = Array.from({ length: 49 }, (_, index) => index);

export type DecorativeDotGridProps = ComponentPropsWithoutRef<'div'>;

export function DecorativeDotGrid({ className, ...props }: DecorativeDotGridProps) {
  return (
    <div
      {...props}
      aria-hidden={props['aria-hidden'] ?? true}
      className={cn('grid grid-cols-7 gap-1.5', className)}
    >
      {DOT_INDICES.map((index) => (
        <div key={index} className="h-1.25 w-1.25 rounded-full bg-brand-primary opacity-30" />
      ))}
    </div>
  );
}
